import { useEffect, useRef, useState } from "react";
import styles from "./ClientsView.module.css";
import { useSelector, useDispatch } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import CollabModalDetails from "../collabs/CollabModalDetails";
import moment from "moment";
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { getTeams, setSelectedTeams } from "../../components/teams/teamsSlice";
import ManagersListModal from "./ManagersListModal";
import CollabsListModal from "./CollabsListModal";
import TeamsDetailsModal from "./TeamsDetailsModal";
import AddTeamModal from "./AddTeamModal";
import { useNavigate, useParams } from "react-router-dom";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import planningIcon from "../../assets/images/planning.png";
import planningIconFocus from "../../assets/images/planningFocus.png";
import archiveIcon from '../../assets/images/archive.png'
import archiveIconFocus from '../../assets/images/archiveFocus.png'
import { isAdmin } from "../../app/utils/helpers";
import InactiveTeamsModel from "./InactiveTeamsModel";
import ExcelManager from "../../app/managers/excelManager";

export default function TeamsTab() {

    const mounted = useRef(null)
    const dispatch = useDispatch()
    const teamsList = useSelector((state) => state.teams.allTeams)
    const isMobile = useSelector((state) => state.settings.isMobile);
    const [managersListModalVisibility, setManagersModalVisibility] = useState(false);
    const [collabsListModalVisibility, setCollabModalListVisibility] = useState(false)
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [displayTeamsDetailsModal, setDisplayTeamsDetailsModal] = useState(false);
    const [onPreviewTeam, setOnPreviewTeam] = useState(null);
    const [addTeamModalVisibility, setAddTeamModalVisbility] = useState(false);
    const urlParams = useParams()
    const dtTeams = useRef(null)
    const navigate = useNavigate()
    const [inactiveModalVisibility, setInactiveModalVisibility] = useState(false);
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const [vfactExpandedId, setVfactExpandedId] = useState(null);
    const [vfactExpanded, setVfactExpanded] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        label: { value: null, matchMode: FilterMatchMode.CONTAINS },
        client: { value: null, matchMode: FilterMatchMode.CONTAINS },
        localization: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sous_service: { value: null, matchMode: FilterMatchMode.CONTAINS },
        country_name: { value: null, matchMode: FilterMatchMode.EQUALS }
    })
    const [filteredData, setFilteredData] = useState(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('')

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getTeams())
        }
        mounted.current = true
    }, [mounted])

    useEffect(() => {
        if (urlParams.view == 'clients' && urlParams.subView == '1' && urlParams.label) {
            onUrlFilterChange(urlParams.label, 'global')
        }
    }, [urlParams])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const onUrlFilterChange = (value, filter) => {
        let _filters = { ...filters };

        _filters[filter].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const exportFilteredData = () => {
        exportTeamsList()
    }

    const header = () => {
        return (
            <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
                <dev>
                    {isAdmin(userRoleId) && <ImageButton
                        image={archiveIcon}
                        imageFocus={archiveIconFocus}
                        onClick={() => setInactiveModalVisibility(true)}
                        active={true}
                        tooltip={<Langs str="Archive" />}
                        width={32} />}
                    <ImageButton
                        image={exportIcon}
                        imageFocus={exportIconFocus}
                        onClick={exportFilteredData}
                        active={true}
                        tooltip="Export"
                        width={32} />
                    <ImageButton
                        image={addIcon}
                        imageFocus={addIconFocus}
                        onClick={() => setAddTeamModalVisbility(true)}
                        active={true}
                        tooltip={<Langs str="ADD_TEAM" />}
                        width={32} />
                </dev>
            </div>
        )
    }

    function getFilteredData() {
        return filteredData ?? teamsList
    }

    const exportTeamsList = () => {
        let exportTeamsList = getFilteredData().reduce((array, current) => {
            let data = {
                "ID": current.id || "",
                "Nom": current.label || "",
                "Client": current.client || "",
                "Localization": current.localization || "",
                "Pays": current.country_name || "",
                "SDM": current.managers ? current.managers.filter(m => m.type == "SDM").map(m => m.prenom + " " + m.nom).join(", ") : "",
                "Manager": current.managers ? current.managers.filter(m => m.type == "MANAGER").map(m => m.prenom + " " + m.nom).join(", ") : "",
                "Sous service": current.sous_service || "",
                "Codes des prestations V-Fact": current.vfact ? current.vfact.split('\n').join(' | ') : ""
            }

            array.push(data)
            return array
        }, [])
        ExcelManager.getInstance().generateAndDownloadExcelFromData(exportTeamsList, "teams")
    }

    const managersMembersBodyButton = (rowData) => {
        return (
            <div>
                <p className="m-0" style={{ color: "blue", textDecoration: "none", cursor: "pointer" }}
                    onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                    onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                    onClick={() => { setSelectedTeam(rowData); setManagersModalVisibility(true) }}
                >
                    • <Langs str='MANAGERS' />
                </p><br />
                <p className="m-0" style={{ color: "green", textDecoration: "none", cursor: "pointer" }}
                    onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                    onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                    onClick={() => { setSelectedTeam(rowData); setCollabModalListVisibility(true) }}
                >
                    • <Langs str='MEMBERS' />
                </p>
            </div>
        )
    }

    const jumpToPlanningButton = (rowData) => {
        return <ImageButton
            image={planningIcon}
            imageFocus={planningIconFocus}
            onClick={() => {
                dispatch(setSelectedTeams([rowData.value]))
                navigate(`/planning/${rowData.value}/MONTHLY${moment().format("DDMMYYYY")}`)
            }}
            active={true}
            tooltip={<Langs str="VIEW_PLANNING" />}
            width={32} />
    }

    const creationDateBodyTemplate = (rowData, column) => {
        if (rowData[column.field]) {
            return <label>
                {moment(rowData[column.field]).format("DD/MM/YYYY HH:mm")}
            </label>
        }
    }

    const vfactTemplate = (rowData) => {
        const vfacts = rowData.vfact ? rowData.vfact.split('\n') : [];
        return (
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                {vfacts.slice(0, (vfactExpanded && vfactExpandedId == rowData.value) ? vfacts.length : 3).map((vfact, index) => (
                    <li key={index} style={{
                        position: 'relative',
                        paddingLeft: '20px',
                        wordWrap: 'break-word',
                        maxWidth: '35ch',
                        marginBottom: '8px'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '0'
                        }}>•</span>
                        {vfact}
                    </li>
                ))}
                {vfacts.length > 3 && !vfactExpanded && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setVfactExpanded(true); setVfactExpandedId(rowData.value) }}>
                        ... {<Langs str="SHOW_MORE" />} ({vfacts.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
                {vfactExpanded && vfactExpandedId === rowData.value && vfacts.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setVfactExpanded(false); setVfactExpandedId(null) }}>
                        {<Langs str="SHOW_LESS" />}
                    </li>
                )}
                {vfactExpanded && vfactExpandedId !== rowData.value && vfacts.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setVfactExpanded(true); setVfactExpandedId(rowData.value) }}>
                        ... {<Langs str="SHOW_MORE" />} ({vfacts.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
            </ul>
        );
    }

    const sdmColBody = (rowData) => {
        if (rowData && rowData.managers) {
            return (
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                    {rowData.managers
                        .filter(manager => manager.type == "SDM")
                        .map((manager, index) => (
                            <li key={index} style={{
                                position: 'relative',
                                paddingLeft: '20px',
                                wordWrap: 'break-word',
                                maxWidth: '35ch',
                                marginBottom: '8px'
                            }}>
                                <span style={{
                                    position: 'absolute',
                                    left: '0',
                                    top: '0'
                                }}>•</span>
                                {manager.prenom} {manager.nom}
                            </li>
                        ))}
                </ul>
            );
        }
    };

    const managerColBody = (rowData) => {
        if (rowData && rowData.managers) {
            return (
                <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                    {rowData.managers
                        .filter(manager => manager.type == "MANAGER")
                        .map((manager, index) => (
                            <li key={index} style={{
                                position: 'relative',
                                paddingLeft: '20px',
                                wordWrap: 'break-word',
                                maxWidth: '35ch',
                                marginBottom: '8px'
                            }}>
                                <span style={{
                                    position: 'absolute',
                                    left: '0',
                                    top: '0'
                                }}>•</span>
                                {manager.prenom} {manager.nom}
                            </li>
                        ))}
                </ul>
            );
        }
    }
    const onRowClickFun = (rowData) => {
        setDisplayTeamsDetailsModal(true)
        setOnPreviewTeam(rowData.data)
    }

    let date = moment().format("DD-MM-YYYY")
    return (
        <div className={styles.bodyContainer}>
            <div className="card p-1 mt-3" style={{ height: 'calc(100vh - 160px)' }}>
                <DataTable ref={dtTeams}
                    exportFilename={`Equipe_export_${date}`}
                    value={teamsList}
                    onValueChange={(data) => setFilteredData(data)}
                    scrollHeight={isMobile === 2 ? "calc(100vh - 200px)" : "calc(100vh - 305px)"}
                    scrollable
                    paginator
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                    rowsPerPageOptions={[10, 25, 50]}
                    rows={10}
                    sortMode="single"
                    globalFilterFields={['label', 'client', 'localization']}
                    filters={filters}
                    header={header}
                    rowClassName={styles.rowClassHover}
                    onRowDoubleClick={onRowClickFun}
                >
                    <Column field="label" filter filterMatchMode={'contains'} filterPlaceholder="nom" sortable header={Localize('TEAM')} style={{ minWidth: '10rem' }} />
                    <Column field="client" filter filterMatchMode={'contains'} filterPlaceholder="Clients" sortable header={Localize('Clients')} style={{ minWidth: '10rem' }} />
                    <Column field="localization" filter filterMatchMode={'contains'} filterPlaceholder="localization" sortable header={Localize('localization')} style={{ minWidth: '10rem' }} />
                    <Column field="country_name" filter filterMatchMode={'equal'} filterPlaceholder="country" sortable header={Localize('country')} style={{ minWidth: '10rem' }} />
                    <Column header={Localize('SDM')} style={{ minWidth: '10rem' }} body={sdmColBody} />
                    <Column header={Localize('Manager')} style={{ minWidth: '10rem' }} body={managerColBody} />
                    <Column field="sous_service" filter filterMatchMode={'contains'} filterPlaceholder="sous service" sortable header={Localize('SOUS_SERVICE')} style={{ minWidth: '10rem' }} />
                    <Column field="vfact" header={Localize('Codes des prestations V-Fact')} body={vfactTemplate} style={{ minWidth: '20rem' }} />
                    <Column field="created_at" header={Localize("created_at")} body={creationDateBodyTemplate} sortable dataType="date" style={{ minWidth: '10rem' }}></Column>
                    <Column field="value" header={''} body={managersMembersBodyButton} alignFrozen="right" frozen={true} style={{ minWidth: '10rem' }} />
                    <Column body={jumpToPlanningButton} style={{ minWidth: '2rem', textAlign: 'right' }} alignFrozen="right" frozen={true}></Column>
                </DataTable>
            </div>
            <ManagersListModal
                visible={managersListModalVisibility}
                setVisible={setManagersModalVisibility}
                idTeam={selectedTeam && selectedTeam.value}
                teamName={selectedTeam && selectedTeam.label}
            />
            <CollabsListModal
                visible={collabsListModalVisibility}
                setVisible={setCollabModalListVisibility}
                idTeam={selectedTeam && selectedTeam.value}
                teamName={selectedTeam && selectedTeam.label}
            />
            <CollabModalDetails
                page="collabs"
                tabs={["contrat", "societe", "mission", "donneesPerso", "profil"]}
            />
            <TeamsDetailsModal
                visible={displayTeamsDetailsModal}
                setVisible={setDisplayTeamsDetailsModal}
                team={onPreviewTeam}
                setTeam={setOnPreviewTeam}
            />
            <AddTeamModal
                visible={addTeamModalVisibility}
                setVisible={setAddTeamModalVisbility}
            />
            <InactiveTeamsModel
                visible={inactiveModalVisibility}
                setVisible={setInactiveModalVisibility}
            />
        </div>
    );
}